import React, { FC } from 'react'

interface StudProps {
  className?: string
}

export const Stud: FC<StudProps> = ({ className }) => {
  return (
    <svg
      className={className}
      fill={'none'}
      height={'100%'} // Use 100% to make it responsive to the container size
      viewBox={'0 0 32 32'}
      width={'100%'} // Use 100% to make it responsive to the container size
      xmlns={'http://www.w3.org/2000/svg'}
    >
      <path
        clipRule={'evenodd'}
        d={
          'M15.5 6.00009C10.2533 6.00009 6 10.2534 6 15.5001C6 20.7468 10.2533 25.0001 15.5 25.0001C20.7467 25.0001 25 20.7468 25 15.5001C25 10.2534 20.7467 6.00009 15.5 6.00009ZM5 15.5001C5 9.7011 9.70101 5.00009 15.5 5.00009C21.299 5.00009 26 9.7011 26 15.5001C26 21.2991 21.299 26.0001 15.5 26.0001C9.70101 26.0001 5 21.2991 5 15.5001Z'
        }
        fill={'#D7D8E1'}
        fillRule={'evenodd'}
      />
    </svg>
  )
}
